import { SocialSignInButton } from '@jusbrasil-web/shared-social-sign-in'
import classNames from 'classnames'
import { ReactNode } from 'react'

import { ENTITY_NOTICE_GOOGLE_BUTTON_TEXT } from '../../experiments/entity-notice-fakedoor'
import styles from './entity-notice-google-picker-button.module.scss'

export interface EntityNoticeGooglePickerButtonProps {
  appId?: string
  featureCode?: string
  fromComponent?: string
  nextUrl?: string
  className?: string
  label?: string
  chip?: ReactNode
}

/**
 * Variant B's own Google option — the picker card look (white background,
 * dark text) is fixed, never a primary/secondary swap by state like cells
 * A/C, so this doesn't share `EntityNoticeGoogleButton`'s kind machinery.
 *
 * `signupData` is intentionally absent — the phone must never become a query
 * param on the Google-callback URL this builds.
 */
export function EntityNoticeGooglePickerButton({
  appId,
  featureCode,
  fromComponent,
  nextUrl,
  className,
  label = ENTITY_NOTICE_GOOGLE_BUTTON_TEXT,
  chip,
}: EntityNoticeGooglePickerButtonProps) {
  return (
    <div className={classNames(styles.root, className)}>
      {chip && <div className={styles.chip}>{chip}</div>}
      {/* Anti-pattern look, deliberate: kind="primary" only for SocialSignInButton's
          logo-badge sizing — every color below overrides it regardless. */}
      <SocialSignInButton
        provider="google"
        kind="primary"
        appId={appId ?? ''}
        featureCode={featureCode ?? ''}
        fromComponent={fromComponent ?? 'EntityNoticeEntry'}
        nextUrl={nextUrl ?? ''}
      >
        {label}
      </SocialSignInButton>
    </div>
  )
}
